<template>
    <basic-card>
        <template #header>{{ $t('accounts.account') }} {{account.name}}</template>
        <apex-chart v-if="typeof accountBalances(account) != 'undefined'"
                    width="100%" height="200px" type="area" :options="chartOptions" :series="series"/>
        <form-wrapper>
            <form-text-input v-model="account.id" caption="Id" disabled/>
          <form-checkbox-input v-model="account.active" :caption="`${$t('accounts.active')}`"/>
            <form-checkbox-input v-model="account.internal" :caption="`${$t('accounts.internal')}`"/>
            <form-text-input help-item-code="account-name" v-model="account.name" :caption="`${$t('accounts.name')}`"/>
            <form-text-input help-item-code="account-alias" v-model="account.alias" :caption="`${$t('accounts.alias')}`"/>
            <form-text-input help-item-code="account-eBankingName" v-model="account.eBankingAccountNumber" :caption="`${$t('accounts.eBankingName')}`"/>
            <form-text-input help-item-code="account-type" v-model="account.type" :caption="`${$t('accounts.type')}`"/>
            <form-text-input help-item-code="account-account-number" v-model="account.accountNumber" :caption="`${$t('accounts.number')}`"/>
            <form-text-input help-item-code="account-iban" v-model="account.iban" :caption="`${$t('accounts.iban')}`"/>
<!--            <form-text-input v-model="account.bic" caption="BIC"/>-->
            <form-select-input help-item-code="account-currency" v-model="account.currency" :caption="`${$t('accounts.currency')}`" :options="currenciesOptions" :custom-renderer="customRenderers.CurrencyVisualizer"/>
            <form-select-input help-item-code="account-bank" v-model="account.bankId" :caption="`${$t('accounts.bank')}`" :options="banksOptions"/>

            <form-text-input help-item-code="account-overdraft" v-model="account.overdraftLimit"  :caption="`${$t('accounts.owerdraftLimit')}`"/>
            <form-select-input help-item-code="account-owner" v-model="accountOwnership.partyRoleId" :caption="`${$t('accounts.owner')}`" :options="partyOptions"/>
            <form-color-input help-item-code="account-color" v-model="account.vizColor" :caption="`${$t('accounts.visualizationColor')}`"/>
            <form-geo-input help-item-code="account-geo" v-model="account.geoPoint" :caption="`${$t('accounts.location')}`"/>
            <form-select-input help-item-code="account-security-group" v-model="account.securityGroup" :options="securityGroups" :caption="`${$t('accounts.securityGroup')}`"/>
        </form-wrapper>

        <simple-button confirmation-protected
                       :protection-message="`${$t('accounts.savingAccount')} ${account.name}`"
                       @proceed="handleSave">
            {{ $t('save') }}</simple-button>
    </basic-card>
</template>

<script>
    import BasicCard from "../components/layout/BasicCard";
    import FormTextInput from "../components/form/FormTextInput";
    import FormWrapper from "../components/form/FormWrapper";
    import FormSelectInput from "../components/form/FormSelectInput";
    import {mapGetters} from "vuex";
    import SimpleButton from "../components/button/SimpleButton";
    import FormCheckboxInput from "../components/form/FormCheckboxInput";
    import FormColorInput from "../components/form/FormColorInput";
    import FormGeoInput from "@/components/form/FormGeoInput";

    export default {
        name: "AccountFormCard",
        components: {
          FormGeoInput,
            FormColorInput,
            FormCheckboxInput, SimpleButton, FormSelectInput, FormWrapper, FormTextInput, BasicCard},
        props: {
            account: Object,
            accountOwnership: {
                type: Object,
                default: () => ({ })
            }
        },
        data: function () {
            return {
            }
        },
        computed: {
            ... mapGetters({
                "supportedPartyRoleIds": "accountOwnerships/supportedPartyRoleIds",
                "currenciesOptions": "currencies/currenciesOptions",
                "parties": "parties/parties",
                "accountBalances": "banking/accountBalances",
                "securityGroups": "securityGroups/securityGroups"
            }),
            banksOptions() {
              return this.parties.map(party => ({name: party.displayName, id: party.id}))
            },
            partyOptions() {
                return this.parties.filter(
                    party => {
                        return party.partyRoles.some(partyRole => {
                            return this.supportedPartyRoleIds.includes(partyRole.partyRoleTypeId) &&
                                partyRole.attributeComponent.values.AccountOwner.InternalAccountOwner == this.account.internal;
                        })
                    }
                ).map(party => ({name: party.displayName, id: party.partyRoles.filter(partyRole => this.supportedPartyRoleIds.includes(partyRole.partyRoleTypeId))[0].id}))
            },
            chartOptions() {
                return {
                    chart: {
                        id: 'vuechart-example'
                    },
                    dataLabels: {
                        enabled: false
                    },
                    fill: {
                        type: 'gradient',
                        gradient: {
                            shadeIntensity: 0,
                            opacityFrom: 0.65,
                            opacityTo: 0,
                            stops: [0, 100]
                        }
                    },
                    colors: ["#d24d4e"],
                    labels: this.accountBalances(this.account).map(balance => balance.balanceDate),
                    xaxis: {
                        type: 'datetime',
                        labels: {
                            style: {
                                colors: "#acacac"
                            }
                        },
                        axisBorder: {
                            show: false
                        },
                        axisTicks: {
                            show: false
                        }
                    },
                    yaxis: {
                        labels: {
                            style: {
                                color: "#acacac"
                            },
                            formatter: (val) => this.$numeral(val / 100000).format('0,0.00') + "k"
                        },
                        axisBorder: {
                            show: false
                        }
                    },
                    grid: {
                        show: true,
                        borderColor: "#566371",
                        yaxis: {
                            lines: {
                                show: false
                            },
                        },
                        xaxis: {
                            lines: {
                                show: true
                            }
                        }
                    }

                }
            },
            series() {
                return [{
                    name: this.account.name,
                    data: this.accountBalances(this.account).map(balance => balance.endBalance)
                }];
            }
        },
        methods: {
            handleSave() {
                this.$emit("save", this.account, this.accountOwnership);
            }
        }
    }
</script>

<style lang="scss" scoped>
@import "../styles/global";
</style>
